// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';

export const updateCloseAccountIndex = index => ({
    accountIndex: index,
    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT_INDEX
});




// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/close-account-index.js